// Üretim Raporları sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.reports';

export const productionReportsGuide = (t: TFunction): GuideContent => ({
  layout: 'report',
  title: t(`${G}.title`, 'Üretim Raporları nasıl okunur?'),
  intro: t(`${G}.intro`, 'Tamamlanmış üretim fişlerinden verim, malzeme tüketimi, maliyet sapması ve kalite raporları alırsınız. Raporlar yalnız okur, stoğa ve maliyete dokunmaz; maliyetler fişte kayıtlı değerlerden gelir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve rapor sekmeleri'),
    actions: t(`${G}.regions.actions`, 'Excel'),
    filters: t(`${G}.regions.filters`, 'Tarih, depo, ürün filtreleri'),
    totals: t(`${G}.regions.totals`, 'Toplamlar ve grafik'),
    table: t(`${G}.regions.table`, 'Rapor tablosu'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Raporu seçin'),
      text: t(`${G}.s1.text`, 'Üstteki sekmelerden (telefonda açılır listeden) raporu seçin. "Eksi Stok Yarı Mamuller" ve "Kalite" dışındaki raporlar yalnız tamamlanmış fişleri sayar; Kalite, iptal edilmemiş tüm fişlerdeki ölçümleri sayar.'),
      tips: [
        t(`${G}.s1.tip1`, 'Üretim Özeti: ürün bazında fiş sayısı, planlanan ve üretilen miktar, verim, standart ve fiili maliyet ile sapma.'),
        t(`${G}.s1.tip2`, 'Malzeme Tüketimi: her malzemenin beklenen (üretilen miktara oranlanmış reçete miktarı) ve fiili tüketimi ile farkı; reçete dışı eklenen satır sayısı.'),
        t(`${G}.s1.tip3`, 'Yan Ürün / Hurda: ortak ürün, yan ürün ve hurda çıktılarının miktarı ve dağıtılan maliyeti. Maliyet Sapması: fiş bazında standart ve fiili birim maliyet farkı.'),
        t(`${G}.s1.tip4`, 'Eksi Stok Yarı Mamuller: reçetesi olan ve deposunda stoğu eksiye düşmüş ürünler; o anki stoktan hesaplanır, tarihe bağlı değildir.'),
        t(`${G}.s1.tip5`, 'İstasyon Dönüşüm ve Kalite yalnız Üretim - Operasyonlar modülü açıkken görünür: istasyon başına plan/gerçek süre ve maliyet, sağlam/fire; kontrol ve ürün bazında kalite sonuçları.'),
        t(`${G}.s1.tip6`, 'Kişi Bazında Verim: fişi tamamlayan kişiye ve ürüne göre fiş sayısı, planlanan ve çıkan miktar, verim, fiş başı min–maks; reçetede ana malzeme yıldızlıysa ana malzeme tüketimi ve ana malzeme başına çıkan (ör. kg hamur başına adet). Reçetede "çıkan miktar değişken" işaretliyse beklenen aralığın dışında kalan fiş sayısı da görünür.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Filtreleyin'),
      text: t(`${G}.s2.text`, 'Başlangıç–Bitiş tarihi (fişin üretim tarihi), depo ve rapora göre ana ürün, malzeme, çıktı tipi ya da "Min. sapma %" ile süzün. Depo filtresi girdi veya çıktı deposu o depo olan fişleri alır. "Filtreleri temizle" hepsini kaldırır.'),
    },
    {
      region: 'totals',
      title: t(`${G}.s3.title`, '3. Toplamları ve grafiği okuyun'),
      text: t(`${G}.s3.text`, 'Tablonun üstündeki kutular filtrenize uyan tüm satırların toplamını verir. Üretim Özeti\'nde fiili maliyeti en yüksek ilk 10 ürün, Maliyet Sapması\'nda bu sayfadaki sapma %, İstasyon Dönüşüm\'de plan ve gerçek süre grafiği bulunur.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Sütunları yorumlayın'),
      text: t(`${G}.s4.text`, 'Sütun başlığına tıklayarak sıralayabilirsiniz. Maliyet Sapması\'nda "Kırılımı göster" malzeme, dönüşüm (makine + işçilik) ve genel gider için standart, fiili ve sapma sütunlarını ekler.'),
      tips: [
        t(`${G}.s4.tip1`, 'Verim %: üretilen miktarın planlanan miktara oranı.'),
        t(`${G}.s4.tip2`, 'Sapma: fiili maliyet eksi standart maliyet. Pozitif değer standardın üstünde maliyet demektir.'),
        t(`${G}.s4.tip3`, 'Hurda Oranı: aynı fişlerdeki hurda miktarının ana ürün üretimine oranı. Birimler farklı olabilir; bilgi amaçlıdır.'),
        t(`${G}.s4.tip4`, 'Eksi Stok Yarı Mamuller\'de "Önerilen Miktar" stoğu sıfıra getirecek miktardır; "Üret" bu ürün, miktar ve depoyla yeni üretim fişi açar.'),
      ],
    },
    {
      region: 'actions',
      title: t(`${G}.s5.title`, '5. Excel\'e aktarın'),
      text: t(`${G}.s5.text`, '"Excel" düğmesi seçili raporu filtrelerinizle indirir; en fazla 5000 satır içerir. Uzun listelerde alttaki sayfalamayı kullanın. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
